import { get } from 'lodash';
import { getData as getPropertyObjectsSaga } from 'modules/App/redux/propertyObjects/saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getData as getPropertyObjectTypesSaga } from 'modules/App/redux/propertyObjectTypes/saga';
import { fetchReceipts } from 'modules/Checks/api';
import {
  completeFormSubmit,
  get2NDFLSuccess,
  get3NDFLDraftSuccess,
  getChecksSuccess,
  save3NDFLDraftError,
  save3NDFLDraftSuccess,
} from '../../components/NDFL3/NDFL3Actions';
import { getData as loadCurrencyList } from '../../redux/currencyList/saga';
import { startRequest as getAvailableYears } from '../../redux/availableYears/actions';
import { get2NDFLByYear, load3NDFLDraft, save3NDFLAsDraft } from '../../services/API';
import {
  addIncomeSourcesBy2NDFL,
  getSocDeductionsBy2NDFL,
  getStdDeductionsBy2NDFL,
  init3NDFLDraft,
  loadInitialDictionaries,
  setCurrentFormId,
  updateInvestmentTaxDeduction,
} from './NDFL3Saga';
import { BASE_ACTIONS, SAGA_ACTIONS } from './NDFL3SagaActionTypes';
import { submit3NDFLXmlDraft } from 'modules/Taps/redux/ndfl3Saga/NDFL3Saga';
import { loadingFinish, loadingStart } from './NDFL3SagaActions';
import {
  getNextOrBackStep,
  getStepIndexByRouter,
} from '../../components/NDFL3/NDFL3ActionsService';
import * as urlHelper from '../../../../utils/urlHelper';
import { push, replace, unblock } from 'redux-little-router';
import { getStepsMapByYear } from '../../components/NDFL3/constants/Ndfl3StepsMapping';
import { update3NDFLFormDraft } from './NDFL3SagaEffects';
import errorMessages from '../../../../constants/errorMessages';
import { routeMap } from 'router';
import { selectYear } from 'modules/Taps/components/NDFL3Light/selectors';
import { DEFAULT_REPORT_YEAR, NDFL_FORM_ID } from 'modules/Taps/components/NDFL3/constants/forms';
import { change, formValueSelector } from 'redux-form/immutable';

const selector = formValueSelector(NDFL_FORM_ID);
import REACT_CONFIG from 'REACT_CONFIG';

export function* loadNdfl2(reportYear) {
  const response = yield call(get2NDFLByYear, reportYear);
  const ndflByYear = response.data || [];

  if (response.isOk) {
    yield put(get2NDFLSuccess(ndflByYear));
  }

  return response;
}

export function* beforeStep(ndfl3State, beforeStep) {
  const ndfl3Package = ndfl3State.ndfl3Package;
  const reportYear = ndfl3Package.payload.initialData.reportYear;

  if (beforeStep === 0) {
    yield put(getAvailableYears(ndfl3Package.mode));
  }

  if (beforeStep === 1) {
    yield loadCurrencyList({});
    const response = yield loadNdfl2(reportYear);

    if (response.isOk) {
      const internalSources = get(ndfl3State, 'ndfl3Package.payload.sheetA.sources', []);
      const externalSources = get(ndfl3State, 'ndfl3Package.payload.sheetB.sources', []);
      yield getPropertyObjectsSaga({});

      if (!internalSources.length && !externalSources.length) {
        yield addIncomeSourcesBy2NDFL();
      }
    }

    if (ndfl3State.ndfl3Package.payload.useReturnClaim) {
      yield put(change(NDFL_FORM_ID, 'Ndfl3Package.payload.useReturnClaim', null));
    }
  }

  if (beforeStep === 3) {
    if (!REACT_CONFIG.REACT_APP_HIDE_CHECKS) {
      const defaultSize = 2000;
      const checks = yield call(fetchReceipts, { size: defaultSize });
      if (checks && checks.totalElements > defaultSize) {
        const updatedChecks = yield call(fetchReceipts, { size: checks.totalElements });
        yield put(getChecksSuccess(updatedChecks));
      } else {
        yield put(getChecksSuccess(checks));
      }
    }

    if (ndfl3State.ndfl3Package.payload.deductionSelector.standardDeduction) {
      yield loadNdfl2(reportYear);
      yield getStdDeductionsBy2NDFL();
    }

    if (ndfl3State.ndfl3Package.payload.deductionSelector.propertyDeduction) {
      yield all([
        getPropertyObjectsSaga({}),
        getPropertyObjectTypesSaga({}),
        BASE_ACTIONS.GET_PROPERTY_RIGHTS.sagaFunction({}),
        BASE_ACTIONS.GET_OBJECT_NAME_CODES.sagaFunction({}),
        BASE_ACTIONS.GET_TAX_DEDUCTION_OWNER_CODES.sagaFunction({
          payload: { year: ndfl3State.ndfl3Package.payload.initialData.reportYear },
        }),
      ]);
    }

    if (ndfl3State.ndfl3Package.payload.deductionSelector.socialDeduction) {
      // Вычисляет социальные налоговые вычеты
      // (по данным налогового агента) на основе переданных данных справок 2-ндфл
      yield getSocDeductionsBy2NDFL();
    }

    if (ndfl3State.ndfl3Package.payload.useReturnClaim) {
      yield put(change(NDFL_FORM_ID, 'Ndfl3Package.payload.useReturnClaim', null));
    }
  }

  if (beforeStep === 4) {
    yield updateInvestmentTaxDeduction(ndfl3Package);

    if (reportYear < 2020) {
      yield submit3NDFLXmlDraft({ ndfl3Package, reportYear });
      yield call(BASE_ACTIONS.GET_FILES_CATEGORIES.sagaFunction, {
        payload: { year: ndfl3State.ndfl3Package.payload.initialData.reportYear },
      });
    }
  }

  if (beforeStep === 5) {
    yield submit3NDFLXmlDraft({ ndfl3Package, reportYear });
    yield call(BASE_ACTIONS.GET_FILES_CATEGORIES.sagaFunction, {
      payload: { year: ndfl3State.ndfl3Package.payload.initialData.reportYear },
    });
  }
}

export function* goPrevStepSaga() {
  const sagaFunction = function* () {
    yield put(loadingStart());
    const state = yield select((state) => state);
    const nextStepIndex = getNextOrBackStep(state);
    const cardId = urlHelper.getParameterByName('cardId');
    const ndfl3State = yield select((state) => state.taps.ndfl3);
    const formState = selector(state, `Ndfl3Package`);
    const reportYear = formState.getIn(['payload', 'initialData', 'reportYear']);
    const stepsMap = getStepsMapByYear(reportYear);

    yield beforeStep(ndfl3State, nextStepIndex);
    yield put(
      push({
        query: {
          cardId: cardId,
          step: stepsMap[nextStepIndex].name,
        },
      }),
    );
    yield put(loadingFinish());
  };

  yield takeLatest(SAGA_ACTIONS.GO_PREV_STEP, sagaFunction);
}

export function* saveAndGoNextStep() {
  const sagaFunction = function* ({ payload: { isDeclarationSubmitStep } }) {
    yield put(loadingStart());
    const state = yield select((state) => state);
    const ndfl3Package = setCurrentFormId(state);
    const reportYear = ndfl3Package.getIn(['payload', 'initialData', 'reportYear']);
    // do not updated draft after  TP was submitted
    if (!isDeclarationSubmitStep) {
      const currentFormId = ndfl3Package.get('currentFormId');
      const response = yield call(
        save3NDFLAsDraft,
        currentFormId !== 'overpayments'
          ? ndfl3Package
          : ndfl3Package.set('currentFormId', 'submit'),
        reportYear,
      );
      if (response.isOk) {
        yield update3NDFLFormDraft(response.data);
        yield put(save3NDFLDraftSuccess(response.data));
        const state = yield select((state) => state);
        const nextStepIndex = getNextOrBackStep(state, true);
        const ndfl3State = yield select((state) => state.taps.ndfl3);

        yield beforeStep(ndfl3State, nextStepIndex);
        const stepsMap = getStepsMapByYear(reportYear);
        const stepName = get(stepsMap[nextStepIndex], 'name');
        const cardId = response.data.cardId;
        // добавляем в url cardId черновика и шаг заполнения декларации
        yield put(
          push({
            query: {
              cardId: cardId,
              step: stepName,
            },
          }),
        );
      } else {
        yield put(
          save3NDFLDraftError(
            get(response, 'error.response.status') !== 500 &&
              get(response, 'error.response.data.reason.description')
              ? get(response, 'error.response.data.reason.description')
              : errorMessages.defaultServerError,
          ),
        );
      }
    } else {
      yield put(completeFormSubmit());
    }
    yield put(loadingFinish());
  };
  yield takeLatest(SAGA_ACTIONS.SAVE_AND_GO_NEXT, sagaFunction);
}

export function* goToStep() {
  function* sagaFunction(action) {
    yield put(loadingStart());
    const nextStepIndex = action.payload.stepIndex;
    const cardId = urlHelper.getParameterByName('cardId');
    const state = yield select((state) => state);
    const ndfl3State = yield select((state) => state.taps.ndfl3);
    const formState = selector(state, `Ndfl3Package`);
    const reportYear = formState.getIn(
      ['payload', 'initialData', 'reportYear'],
      DEFAULT_REPORT_YEAR,
    );
    const stepsMap = getStepsMapByYear(reportYear);
    let stepName = stepsMap[nextStepIndex].name;

    yield beforeStep(ndfl3State, nextStepIndex);

    yield put(
      push({
        query: {
          cardId: cardId,
          step: stepName,
        },
      }),
    );
    yield put(loadingFinish());
  }

  yield takeLatest(SAGA_ACTIONS.GO_TO_STEP, sagaFunction);
}

export function* initNDFL3PageSaga() {
  const sagaFunction = function* () {
    yield put(loadingStart());
    const cardId = urlHelper.getParameterByName('cardId');
    // если url содержит cardId, загружаем черновик
    if (cardId) {
      const { isOk, data } = yield call(load3NDFLDraft, cardId);
      if (isOk && data) {
        yield update3NDFLFormDraft(data);
        yield put(get3NDFLDraftSuccess(data));
      } else {
        yield put(unblock());
        yield put(replace(routeMap.declarations));
        return;
      }
    } else {
      yield init3NDFLDraft();
    }
    yield loadInitialDictionaries();
    const ndfl3State = yield select((state) => state.taps.ndfl3);
    const year = yield select(selectYear);
    yield beforeStep(ndfl3State, getStepIndexByRouter(getStepsMapByYear(year)));
    yield put(loadingFinish());
  };

  yield takeLatest(SAGA_ACTIONS.INIT_NDFL3_PAGE, sagaFunction);
}
